export default "__VITE_PUBLIC_ASSET__28008d39__"